"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nRouter = void 0;
const i18nRouter_1 = __importDefault(require("./i18nRouter"));
exports.i18nRouter = i18nRouter_1.default;
//# sourceMappingURL=index.js.map